import { createFileRoute } from "@tanstack/react-router";

import { ServicePage } from "@/features/catalog/pages";

export const Route = createFileRoute("/_app/catalog/services/$serviceId")({
  component: Service,
});

function Service() {
  const { serviceId } = Route.useParams();
  return <ServicePage key={serviceId} serviceId={serviceId} />;
}
